<template>
    <div class="flex w-full h-screen bg-gray-50">
        <div class="flex-1 w-full overflow-y-auto">
            <Topbar />
            <div class="p-8" style="margin-top:64px;">
                <div class="flex justify-center items-center mb-6 relative">
                    <div class="absolute left-0">
                        <RouterLink to="/sale" class="flex-none text-red-500 rounded-xl hover:text-red-700 cursor-pointer"> Назад </RouterLink>
                    </div>
                    <h2 class="text-2xl font-bold flex items-center gap-2">
                        <span class="pi pi-users text-2xl mr-2"></span> Заказ  <span class="text-blue-500" v-if="sale">{{ sale.sale_id }}</span>
                    </h2>
                </div>  
                <Toast />
                <div class="card">
                    <div class="flex flex-row justify-start gap-1 mb-4" v-if="sale">
                      <FloatLabel variant="on">
                        <label for="on_label">Дата и время</label>
                        <InputText id="on_label" v-model="sale.date" disabled variant="outlined"/>
                      </FloatLabel>
                      <FloatLabel variant="on">
                        <label for="on_label" class="z-10">Флорист</label>
                        <InputText id="on_label" v-model="sale.employee.name" disabled variant="outlined"/>
                      </FloatLabel>
                      <FloatLabel variant="on">
                        <label for="on_label" class="z-10">Клиент</label>
                        <InputText id="on_label" v-model="sale.client.name" disabled variant="outlined"/>
                      </FloatLabel>
                      <FloatLabel variant="on">
                        <label for="on_label" class="z-10">Банк</label>
                        <InputText id="on_label" v-model="sale.bank" disabled variant="outlined"/>
                      </FloatLabel>
                      <FloatLabel variant="on">
                        <label for="on_label" class="z-10">Счет</label>
                        <InputText id="on_label" v-model="sale.account" disabled variant="outlined"/>
                      </FloatLabel>
                      <FloatLabel variant="on">
                        <label for="on_label" aria-disabled>Цена после списания бонусов</label>
                        <InputText id="on_label" v-model="sale.price_after_discount" disabled variant="outlined"/>
                      </FloatLabel>
                    </div>
                    <DataTable v-model:expandedRows="expandedRows" :value="saleItems" dataKey="id" showGridlines
                            @rowExpand="onRowExpand" @rowCollapse="onRowCollapse" tableStyle="min-width: 60rem">
                        <Column expander style="width: 5rem" />
                        <Column field="product_type" header="Тип заказа">
                            <template #body="slotProps">
                                {{ resolveSaleItemTitle(slotProps.data) }}
                            </template>
                        </Column>
                        <Column field="product_level" header="Уровень сложности"></Column>
                        <Column field="quantity" header="Количество"></Column>
                        <Column field="unit_price" header="Цена/ед.">
                            <template #body="slotProps">
                                {{ formatCurrency(slotProps.data.unit_price) }}
                            </template>
                        </Column>
                        <Column field="total_price" header="Итог. цена">
                            <template #body="slotProps">
                                {{ formatCurrency(slotProps.data.total_price) }}
                            </template>
                        </Column>
                        <template #expansion="slotProps">
                            <div class="flex flex-column justify-between mb-2">
                                <div class="text-bold text-lg"> {{ resolveSaleItemTitle(slotProps.data) }}</div>
                                <div class="text-bold text-lg"> Тариф за сбор заказа: {{ slotProps.data.order_collection_rate }}</div>
                            </div>
                            <DataTable :value="slotProps.data.components">
                                <Column field="barcode"         header="Штрихкод" sortable></Column>
                                <Column field="name"            header="Наименование" sortable></Column>
                                <Column field="classification"  header="Класс" sortable></Column>
                                <Column field="category"        header="Категория" sortable></Column>
                                <Column field="description"     header="Описание" sortable></Column>
                                <Column field="quantity"        header="Количество" sortable></Column>
                                <Column field="unit_price"      header="Закупочная цена/ед." sortable></Column>
                                <Column field="total_price"     header="Себестоимость итого" sortable>
                                    <template #body="slotProps">
                                        {{ formatCurrency(slotProps.data.total_price) }}
                                    </template>
                                </Column>
                            </DataTable>
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useToast } from 'primevue/usetoast';
import Toast from 'primevue/toast';
import axios from '../lib/axios'
import { useRoute, useRouter } from 'vue-router'

const sale = ref();
const saleItems = ref();
const expandedRows = ref({});
const EXTRA_WORK_ORDER_TYPE_ID = 9
const toast = useToast();
const route = useRoute()
const router = useRouter()
const saleId = route.params.id

const back = () => {
    router.push({ name: 'Sale' })
}

const onRowExpand = (event) => {
    toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
};
const onRowCollapse = (event) => {
    toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
};
const expandAll = () => {
    expandedRows.value = saleItems.value.reduce((acc, p) => (acc[p.id] = true) && acc, {});
};
const collapseAll = () => {
    expandedRows.value = null;
};
const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'KZT' });
};

const resolveSaleItemTitle = (item) => {
    if (item?.title) {
        return String(item.title).trim()
    }

    return Number(item?.order_type_id || 0) === EXTRA_WORK_ORDER_TYPE_ID
        ? 'Доп работа'
        : item?.product_type || ''
}

const getSaleItems = async () => {
    const response = await axios.get(`/api/sale-items/${saleId}`);
    sale.value = response.data;
    saleItems.value = sale.value.items;
    console.log(saleItems.value);
    console.log(sale.value);
}
onMounted(() => {
    getSaleItems();
});
</script>
